/**
 * Legacy module — preserved empty so `acme.common.service.posConfigSettings`
 * keeps resolving. Real impl (internal sub-service of PosConfigService, not
 * downgrade-registered):
 *   apps/b2b-frontend/app/core/pos-config/settings/pos-config-settings.service.ts
 * Wave 3 item #17.
 */
angular.module('acme.common.service.posConfigSettings', []);
